import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const problems = ['Entrenás horas pero en el partido no te sale nada', 'Te cansás rápido en el último cuarto y perdés efectividad', 'No sabés qué entrenar ni cómo progresar de verdad', 'Sentís que tu técnica no mejora y seguís cometiendo los mismos errores', 'Te falta confianza en situaciones de presión y no tomás buenas decisiones', 'No tenés un plan claro y entrenás sin dirección'];
export function Problems() {
  return <section className="w-full bg-white py-12 md:py-16 px-4" data-id="element-98">
      <div className="max-w-4xl mx-auto" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-4 mb-8" data-id="element-100">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-3 p-4 bg-red-50 border-l-4 border-red-500 rounded-r-lg" data-id="element-101">
              <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-102" />
              <p className="text-gray-800 font-medium" data-id="element-103">{problem}</p>
            </motion.div>)}
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-xl md:text-2xl font-bold text-center text-gray-900 mb-6" data-id="element-104">
          Este sistema está pensado para este tipo de problemas:
        </motion.p>
      </div>
    </section>;
}